import List from '@utils/list'
import Options from '@utils/common/options'
const { Search, Table, Operation } = List

function score(this: any, row: any) {
  this.$router.push({ name: 'Performance.Qualitativescore.Score', params: { id: row.id }})
}

const operation = new Operation('performance.qualitativescore')
  .add('score').handle(score)

const options = new Options('performance.qualitativescore')
  .add('0', 'Y')
  .add('1', 'N')

const search = new Search('performance.qualitativescore')
  .placeholder('searchPlaceholder')
  .add('purchaseUnitNo').select('/purchaseUnit/getPurchaseUnitPage', { usingFlag: '1' })
  .add('performanceDate').merge('date').label('performanceDate').attrs({ type: 'month', format: 'yyyy-MM' })

const table = new Table('performance.qualitativescore')
  .type('index')
  .add('formulaName')
  .add('purOfficeName')
  .add('performanceDate')
  .add('adddate')
  .add('status').op(options)

export default new List()
  .url('/srmQualitativeScore/getSrmQualitativeScoreHeadPageByParams', process.env.VUE_APP_PURCHASE_API)
  .search(search)
  .operation(operation)
  .table(table)
  .end()
